import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { PreloaderHandler, DOTS_FULL, MULTICOLOR_FULL, BLUE_FULL } from '../../preloader/preloader-handler';
import { OidcSecurityService } from '../../../auth/services/oidc.security.service';
import { ListWidgetService } from './list-widget.service';
import { ListWidgetModel } from '../../models/widget-related/ListWidgetModel';
import { NotificationHandlerService } from '../../notifications/notification-handler.service';

@Component({
    selector: 'list-widget',
    templateUrl: 'list-widget.component.html'
})

export class ListWidgetComponent {

    @Input() widget: string;
    @Input() widgetId: string;
    @Output() export = new EventEmitter();
    public data: ListWidgetModel;
    public preloaderHandler: PreloaderHandler;

    constructor(private _widgetService: ListWidgetService,
        private _notificationService: NotificationHandlerService,
        public oidcSecurityService: OidcSecurityService) {
        let timeout = 850;
        let itemLoadCount = 1;
        this.preloaderHandler = new PreloaderHandler(itemLoadCount, timeout, BLUE_FULL);
    }

    ngOnInit(): void {
        this.getData();
    }

    private refreshData(): void {
        this.preloaderHandler.reset();
        this.getData();
    }

    private exportData(): void {
        this.export.emit(this.data);
    }

    private rowDetails(rowId: string): void {
        //console.log('Display: RowId-' + rowId + ', Type-' + this.data.Type);
    }

    private getData(): void {
        this._widgetService
            .Get(this.widget, this.widgetId)
            .subscribe(data => {
                this.data = data
            },
            error => {
                this.oidcSecurityService.handleError(error),
                this._notificationService.handleError(error)
            },
            () => {
                this.preloaderHandler.itemLoaded()
            });
    }

}



// WEBPACK FOOTER //
// ./angularApp/app/shared/list-widget-container/list-widget/list-widget.component.ts